import type { GameState } from './GameState';
import type { SettingsStore } from './SettingsStore';
import type { SaveManager } from './SaveManager';
import type { ArcRegistry } from './ArcRegistry';

/**
 * Runtime services bundle. One instance per game session, attached to
 * Phaser's game.registry so scenes can access shared state/services
 * via BiomassScene.services.
 */
export interface GameServices {
  state: GameState;
  settings: SettingsStore;
  saveManager: SaveManager;
  arcs: ArcRegistry;
}

export const SERVICES_KEY = 'biomassServices';
